$('.casestudylist__button').on('click', function(e) {
    e.preventDefault();

    let $this = $(this);  
    let $target = $this.closest('.component').find('.casestudylist__hidden');
    $target.addClass('casestudylist__hidden--extend');
    $this.css("display", "none");
  });